'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const { createFragmentContainer, graphql } = require('react-relay/compat');
const get = require('lodash.get');

const InfoIcon = require('dibs-vg/dist/react/info-circle');
const styles = require('./AffirmPromo.scss');

const AffirmDisplay = require('./AffirmDisplay');

class AffirmPromo extends React.Component {
    componentDidMount() {
        this.refreshAffirm();
    }

    componentDidUpdate() {
        this.refreshAffirm();
    }

    formatPrice(amount) {
        // Amount in cents
        return amount * 100;
    }

    refreshAffirm() {
        if (get(window, 'affirm.ui.isReady')) {
            window.affirm.ui.refresh();
        }
    }

    render() {
        const { viewer, user, item } = this.props;

        const price = get(item, 'pricing.totalAmount.convertedAmounts.USD');
        const priceAmount = this.formatPrice(price);

        return (
            <AffirmDisplay viewer={viewer} item={item} user={user}>
                <div className={styles.container}>
                    <span
                        className={`${styles.promoCopy} affirm-as-low-as`}
                        data-promo-id="promo_set_default"
                        data-affirm-color="black"
                        data-learnmore-show="false"
                        data-amount={priceAmount}
                    />

                    <a
                        className={`${styles.learnMoreButton} affirm-product-modal`}
                        data-promo-id="promo_set_default"
                        data-amount={priceAmount}
                    >
                        <InfoIcon />
                    </a>
                </div>
            </AffirmDisplay>
        );
    }
}

AffirmPromo.propTypes = {
    viewer: PropTypes.object,
    item: PropTypes.object,
    user: PropTypes.object,
};

module.exports = createFragmentContainer(AffirmPromo, {
    viewer: graphql`
        fragment AffirmPromo_viewer on Viewer {
            ...AffirmDisplay_viewer
        }
    `,
    item: graphql`
        fragment AffirmPromo_item on Item {
            ...AffirmDisplay_item
            pricing {
                totalAmount {
                    convertedAmounts {
                        USD
                    }
                }
            }
        }
    `,
    user: graphql`
        fragment AffirmPromo_user on User {
            ...AffirmDisplay_user
        }
    `,
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Affirm/AffirmPromo.jsx